<section id="overlay">
  <div class="box">
    <h3>Lieferstop</h3>
    <p>Der Kunde dieses Tickets wurde mit einem Lieferstop versehen. <br> Möchten Sie das Ticket dennoch bearbeiten?</p>
    <ion-chip class="button-chip" mode="ios" (click)="deliveryStopClosed.emit(false)">Trotzdem öffnen</ion-chip>
  </div>
</section>